<script>
    import Button,{ Label } from '@smui/button';
    import Card from '@smui/card';
    import FormField from '@smui/form-field';
    import Radio from '@smui/radio';
    import Textfield from "@smui/textfield";
    import HelperText from "@smui/textfield/helper-text/index";
    import moment from "moment";
    import { onDestroy,onMount } from "svelte";
    import Datepicker from "svelte-calendar";
    import { get } from "svelte/store";
    import API from "../API/API";
    import DownsampleRate from "../Enums/DownsampleRate";
    import LoadState from "../Enums/LoadState";
    import GeoHelper from "../Helpers/GeoHelper";
    import { getOneYearAgo } from "../Helpers/Misc/timeHelper";
    import MapLayer from "../Map/Enums/MapLayer";
    import MapLayerManager from "../Map/MapLayerManager";
    import MapStore from "../Map/Store";
    import Aircraft from "../Models/Aircraft";
    import AircraftProperty from "../Models/Enums/AircraftProperty";
    import AircraftSpireDataPropertyMap from "../Models/Enums/AircraftSpireDataPropertyMap";
    import MenuItem from "../UI/FlyoutMenu/MenuItem.svelte";
    import InfoCardStore from "../UI/InfoCard/Store";
    import AviationKeyComponent from "../UI/Key/AviationKeyComponent.svelte";
    import LayerListSwitch from "../UI/LayerList/LayerListSwitch.svelte";
    import Spinner from "../UI/Spinner/Spinner.svelte";
    import TimeSlider from "../UI/TimeSlider/TimeSlider.svelte";
    import AircraftHistoryStore from "./AircraftHistoryStore";
    import AircraftResultsTable from "./AircraftResultsTable.svelte";
    import AviationAlertsStore from "./AviationAlertsStore";
    
    // TODO: info card for aircraft.

    const MAX_INPUTS = 10;

    const today = moment().endOf("day").toDate();

    let oneYearAgo = getOneYearAgo();

    let icaoTextAreaValue = AircraftHistoryStore.query.inputString;

    let state = AircraftHistoryStore.meta.loadState;
	let progress = AircraftHistoryStore.meta.progress;
	let error = AircraftHistoryStore.meta.error;
	let lastUpdated = AircraftHistoryStore.meta.lastUpdated;

    let fromFormattedSelected, toFormattedSelected;
    const fromDateTimeStore = AircraftHistoryStore.query.fromDatetime;
	const toDateTimeStore = AircraftHistoryStore.query.toDatetime;
	const invalidInputsStore = AircraftHistoryStore.query.invalidInputs;
    let icaoInputValid = AircraftHistoryStore.query.inputValid;
    let icaoInputLength = AircraftHistoryStore.query.inputLength;

    let downsampling = AircraftHistoryStore.query.downsampling;

    // ^AG:
    // svelte-datepicker sets "start" and "end" to always be 00:00:00 when processing its parameters/data.
    // This is super annoying, so, we force the date to be 23:59:59 formatted, and adjust the datetime when it is submitted to the backend.
    let datePickerStrFormatStart = "#{F} #{j}, #{Y} – #{H}:#{i}:#{s}";//00:00:00";
    let datePickerStrFormatEnd = "#{F} #{j}, #{Y} – 23:59:59"; // #{H}:#{i}:#{s}";//";

    $: queryIsValid = $icaoInputValid && $icaoInputLength <= MAX_INPUTS;


    // 4072EA
    let resultRaw = AircraftHistoryStore.results.raw;
    let aircrafts = AircraftHistoryStore.results.aircrafts;
    let lines = AircraftHistoryStore.results.lines.raw;

    let onSubmit = () => {
        const fromSelected = $fromDateTimeStore;
		const toSelected = $toDateTimeStore;

        const from = moment(new Date(Date.parse(fromSelected))).startOf("day").toDate().toISOString();
        const to = moment(new Date(Date.parse(toSelected))).endOf("day").toDate().toISOString();

        $state = LoadState.LOADING;
        // BAW689
        API.get("aviation/history" +
                "?icao_addresses=" + $icaoTextAreaValue +
                "&timestamp_before=" + to +
                "&timestamp_after=" + from)
            .then((result) => {
                $state = LoadState.LOADED;
                $lastUpdated = Date.now();

                let resultsByAddr = {};
                for (let i = 0; i < result.aircraft.length; i++) {
                    let addr = result.aircraft[i].meta.icao_address;

                    // Aircraft
                    let data = GeoHelper.featureAt(result.aircraft[i].latest.longitude, result.aircraft[i].latest.latitude, result.aircraft[i].latest);
                    data.properties.event = "unknown";

                    let obj = new Aircraft(data, AircraftHistoryStore.aircraftGroup, AircraftSpireDataPropertyMap);
                    obj.uniqidType = AircraftProperty.ICAO_ADDRESS;
                    resultsByAddr[addr] = obj;
                    $aircrafts.push( obj );

                    // Historic path
                    let messageFeatures = [
                        GeoHelper.featureAt(result.aircraft[i].latest.longitude,result.aircraft[i].latest.latitude, result.aircraft[i].latest),
                        ...result.aircraft[i].historic.map((item)=>{
                            return GeoHelper.featureAt(item.longitude, item.latitude, item);
                        })
                    ];
                    obj.generateHistoricPath(messageFeatures);
                }
                $aircrafts = $aircrafts;
                $resultRaw = result;
                AircraftHistoryStore.aircraftGroup.vessels.set( $aircrafts );

                AircraftHistoryStore.actions.updateGeojsonData();

                updateMapWithData();
                updateExtent();
                $lastUpdated = Date.now();

            })
            .catch((err) => {
                $error = err.data.detail;
                if (err.data.detail === "" && err.data.title !== "") {
                    $error = err.data.title;
                }
			    $state = LoadState.INIT;
			    $lastUpdated = Date.now();
            })
    };

    let onClearResults = () => {
        $aircrafts = [];
        AircraftHistoryStore.results.points.raw.set([]);
        AircraftHistoryStore.results.points.filtered.set([]);
        AircraftHistoryStore.results.lines.raw.set([]);
        AircraftHistoryStore.results.lines.filtered.set([]);

        updateMapWithData();
        $state = LoadState.INIT;
		$lastUpdated = Date.now();
    };

    let updateMapWithData = () => {
        // AircraftHistoryStore.actions.updateGeojsonData();
        AircraftHistoryStore.actions.updateMapSources();
    };
    let updateExtent = () => {
		// MapStore.helpers.zoomToFeaturesArray([
		// 	...$aircrafts.map((aircraft) => { return aircraft.currentFeature; })
		// ]);
		MapStore.helpers.zoomToFeaturesArray($lines);
	}

    AircraftHistoryStore.aircraftGroup.vessels.subscribe(() => {
		updateMapWithData();
	});

    onMount(()=>{
        // AircraftHistoryStore.actions.setToEndOfDay();
        AircraftHistoryStore.actions.initMap( MapStore.helpers.getMap() );

        AircraftHistoryStore.aircraftGroup.uniqidType = AircraftProperty.ICAO_ADDRESS;

		InfoCardStore.actions.close();

		// MapStore.actions.setViewType(MapViewType.FLEET_HISTORY);
        MapLayerManager.updateVisibleLayers();
    });
    onDestroy(()=>{
		AircraftHistoryStore.actions.deinitMap();
	});

    let layerHeatmap = AircraftHistoryStore.filters.layers.heatmap.enabled;
    let layerPositions = AircraftHistoryStore.filters.layers.positions.enabled;
    let layerJourneys = AircraftHistoryStore.filters.layers.journeys.enabled;
    let layerAircraft = AircraftHistoryStore.filters.layers.aircraft.enabled;

    let layerChange = event => {
		const targetData = event.target.parentNode.parentNode.parentNode;
		const targetCheckbox = event.target;
        const layer = targetData.dataset.layer;
		const storeKey = targetData.dataset['storekey'];
		const checked = targetCheckbox.checked;

		AircraftHistoryStore.filters.layers[storeKey].enabled.set(checked);
		MapLayerManager.updateVisibleLayers();
	};

    let timeSliderData = AircraftHistoryStore.aircraftGroup.timeSliderData;
	$: {
		// $downsampling;
		$toDateTimeStore;
		$fromDateTimeStore;
		updateTimeSliderMinMax();
	}
	let updateTimeSliderMinMax = () => {
		let minDate = moment($fromDateTimeStore).startOf("day");
		let maxDate = moment($toDateTimeStore).add(1, "day");
		timeSliderData.min.set(minDate);
		timeSliderData.max.set(maxDate);
		timeSliderData.step.set(300); //($downsampling === DownsampleRate.DAILY)?86400:300);
		timeSliderData.value.set(get(timeSliderData.max));
	};

    AircraftHistoryStore.aircraftGroup.timeSliderData.value.subscribe((value) => {
		$aircrafts.forEach(one => one.updateSnapshot(value));
		updateMapWithData();
	});

    let iconMode = AviationAlertsStore.iconMode; // TODO: Global icon mode outside of AviationAlertsStore?
	$: {
		$iconMode;
		const allAircraft = get(AircraftHistoryStore.aircraftGroup.vessels);
		if (allAircraft) {
			allAircraft.forEach((aircraft) => {
                aircraft.setIconMode($iconMode);
                aircraft.updateSnapshot();
            });
            $lastUpdated = Date.now();
			updateMapWithData();
		}
	}


</script>

<MenuItem title={"Query Aircraft History"} materialIcon={"query_builder"}>

    <Textfield fullwidth dense textarea variant="filled"
        bind:value={$icaoTextAreaValue}
        on:input={(e) => AircraftHistoryStore.helpers.onICAOTextareaInput(e)}
        on:change={(e) => AircraftHistoryStore.helpers.onICAOTextareaInput(e)}
        on:focusout={() => AircraftHistoryStore.helpers.onICAOTextareaLoseFocus()}
        input$on:focusout={() => AircraftHistoryStore.helpers.onICAOTextareaLoseFocus()}
        input$maximos={MAX_INPUTS}
        input$maxlength={MAX_INPUTS * (6+1)}
        input$aria-controls="helper-text-fullwidth-textarea"
        input$aria-describedby="helper-text-fullwidth-textarea"
        disabled={$state !== LoadState.INIT}
        label={"ICAO addresses"}
        />
    <HelperText id="helper-text-fullwidth-textarea">Input space/comma separated ICAO Addresses...</HelperText>

    <Datepicker
        start={oneYearAgo}
        end={$toDateTimeStore}
        format={datePickerStrFormatStart}
        bind:selected={$fromDateTimeStore}
        bind:formattedSelected={fromFormattedSelected}
        on:dateSelected={()=>{
            console.log("start date changed?");
        }}
        >
        <Button color="secondary" variant="unelevated" style="width:100%;margin-top:10px;" disabled={$state !== LoadState.INIT}><Label>From: {fromFormattedSelected}</Label></Button>
    </Datepicker>

    <Datepicker
        start={$fromDateTimeStore}
        end={today}
        format={datePickerStrFormatEnd}
        bind:selected={$toDateTimeStore}
        bind:formattedSelected={toFormattedSelected}
        on:dateSelected={()=>{
            console.log("end date changed?");
        }}
    >
    <Button color="secondary" variant="unelevated" style="width:100%;margin-top:5px;" disabled={$state !== LoadState.INIT}><Label>To: {toFormattedSelected}</Label></Button>
    </Datepicker>

    <div style="padding-top:10px;">
        <FormField>
            <Radio bind:group={$downsampling} name="data-downsampling" value={DownsampleRate.MINUTE} disabled={true}/>
            <span slot="label">One point per minute</span>
        </FormField>
    </div>

    {#if $error.length > 0 && $state === LoadState.INIT}
        <Card class="bg-error" padded style="margin-top:10px;">
            <p style="font-weight:bold;">{$error}</p>
        </Card>
    {/if}

    <Button
			id="aircraft-history-submit"
			title="Fetching the data could take several minutes"
			color="secondary"
			variant="unelevated"
			disabled={!queryIsValid || $state === LoadState.LOADING || $state === LoadState.LOADED}
			style="width:100%;margin-top:10px;"
			on:click={onSubmit} >
			<Label>Fetch data</Label>
		</Button>


</MenuItem>

{#if $state === LoadState.LOADING}
    <MenuItem title={"Loading..."} materialIcon={"hourglass_empty"}>
        <Spinner absolute/>
    </MenuItem>
{/if}

{#if $state === LoadState.LOADED}
    <MenuItem title={"Results"} materialIcon={"query_builder"}>
        {#if $aircrafts.length > 0}
            <AircraftResultsTable aircrafts={aircrafts} aircraftGroup={AircraftHistoryStore.aircraftGroup} />
        {:else}
            <Card class="bg-error" style="margin-top:10px;">
                <p style="font-weight:bold;padding-left:10px;padding-right:10px;">Result from query is empty.</p>
            </Card>
        {/if}
        <Button
            id="aircraft-history-clear"
            title="Clear"
            color="secondary"
            variant="unelevated"
            style="width:100%;margin-top:10px;"
            on:click={onClearResults} >
            <Label>Clear Results</Label>
        </Button>
    </MenuItem>
{/if}
{#if $state === LoadState.LOADED && $aircrafts.length > 0}
    <TimeSlider data={timeSliderData} />
	<MenuItem title={"Layers"} materialIcon={"layers"} class="layer-list-component">
        <LayerListSwitch
            label={"ADS-B positions heatmap"}
            data-storekey="heatmap"
            data-layer={MapLayer.AIRCRAFT_HISTORY_HEATMAP}
            checked="{$layerHeatmap}"
            on:change={layerChange}
        />
        <LayerListSwitch
            label={"ADS-B positions"}
            data-storekey="positions"
            data-layer={MapLayer.AIRCRAFT_HISTORY_POINTS}
            checked="{$layerPositions}"
            on:change={layerChange}
        />
        <LayerListSwitch
            label={"Flight journeys"}
            data-storekey="journeys"
            data-layer={MapLayer.AIRCRAFT_HISTORY_LINES}
            checked="{$layerJourneys}"
            on:change={layerChange}
        />
        <LayerListSwitch
            label={"Aircraft"}
            data-storekey="aircraft"
            data-layer={MapLayer.AIRCRAFT_HISTORY_SNAPSHOT}
            checked="{$layerAircraft}"
            on:change={layerChange}
        />
    </MenuItem>
    <AviationKeyComponent defaultModeName="Default" disabled={$state === LoadState.LOADING} />
{/if}